import {
  SET_EXCEPTION_FILTERS,
  RESET_EXCEPTION_FILTERS,
  SET_EXCEPTION_GRID_SORT_CRITERIA,
} from './actionTypes';

export const setExceptionFilters = filters => ({
  type: SET_EXCEPTION_FILTERS,
  filters,
});

export const cleanExceptionFilters = () => ({
  type: RESET_EXCEPTION_FILTERS,
});

export const setGridSortCriteria = sortCriteria => ({
  type: SET_EXCEPTION_GRID_SORT_CRITERIA,
  sortCriteria,
});
